<template>
  <nav class="nav-mobile">
    <input type="checkbox" id="nav" class="hidden"/>
    <label for="nav" class="nav-open"><i></i><i></i><i></i></label>
    <div class="nav-container">
      <ul>
        <li class="nav-item"><router-link class="nav__container__link" to="/" exact>STRONA GŁÓWNA</router-link></li>
        <li class="nav-item"><router-link class="nav__container__link" to="/o-firmie" exact>O FIRMIE</router-link></li>
        <li class="nav-item"><router-link class="nav__container__link" to="/oferta" exact>OFERTA</router-link></li>
        <li class="nav-item"><router-link class="nav__container__link" to="/kontakt" exact>KONTAKT</router-link></li>
        <li class="nav-item"><router-link class="nav__container__link" to="/kariera" exact>KARIERA</router-link></li>
        <li class="nav-item"><router-link class="nav__container__link" to="/polityka-prywatnosci" exact>POLITYKA PRYWATNOŚCI</router-link></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavMobile'
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
